import { action, observable } from 'mobx';

class AutoCompleteClass {
    @observable autocomplete;
    @observable requests = 0;

    // set user location
    @action setAutocomplete(data) {
        this.autocomplete = data;
    }

    @action increaseaRequest() {
        this.requests += 1;
    }
}

const autoCompleteStore = new AutoCompleteClass();
export { autoCompleteStore, AutoCompleteClass };
